import { InspectorContext } from "../reducer";
import { InspectorWeld } from "@/api/hitachi/rbi";
import { PageControls } from "../../../common/PageControls";
import { useContext } from "react";
import { useGetWeldList } from "../queries";
import { WeldSelectionFilters } from "./WeldSelectionFilters";

export function WeldSelection() {
  const { state, updateState } = useContext(InspectorContext);
  const welds = useGetWeldList({
    ...state.filters,
    subProjectId: state.subProject?.id,
    datasheetId: state.datasheet?.datasheetId,
    ndtDiscipline: state.discipline,
    operation: state.operation,
  });

  function handleWeldSelected(e: React.FormEvent<HTMLInputElement>, weld: InspectorWeld) {
    updateState({
      type: "Welds",
      payload: e.currentTarget.checked ? [...state.welds, weld] : state.welds.filter((x) => x.weldId !== weld.weldId),
    });
  }

  if (welds.isLoading) {
    return <p>Loading welds...</p>;
  }

  return (
    <>
      <div className="text-secondary mb-4">
        {state.project?.name} / {state.subProject?.name} / {state.discipline} / {state.operation}
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover text-center text-nowrap">
          <thead>
            <tr>
              <th>Weld Map</th>
              <th>Drawing No.</th>
              <th>Weld ID No.</th>

              {(state.discipline === "UT" ||
                state.discipline === "PMIUT" ||
                state.discipline === "ET" ||
                state.discipline === "PMIET") && (
                <>
                  <th>Work Instruction</th>
                </>
              )}
              <th>
                {welds.data && welds.data.length > 1 && (
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={state.welds.length === welds.data.length}
                    onChange={(e) => {
                      updateState({
                        type: "Welds",
                        payload: e.currentTarget.checked ? welds.data : [],
                      });
                    }}
                  />
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {welds.data?.map((weld, index) => (
              <tr key={index}>
                <td>{weld.weldMap}</td>
                <td>{weld.drawingNumber}</td>
                <td>{weld.weldNumber}</td>

                {(state.discipline === "UT" ||
                  state.discipline === "PMIUT" ||
                  state.discipline === "ET" ||
                  state.discipline === "PMIET") && (
                  <>
                    <td>{weld.workInstruction}</td>
                  </>
                )}
                <td>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={state.welds.some((e) => e.weldId === weld.weldId)}
                    onChange={(e) => handleWeldSelected(e, weld)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex flex-sm-row flex-column justify-content-between">
        <WeldSelectionFilters />
        <PageControls showBack showNext allowNext={state.welds.length > 0} />
      </div>
    </>
  );
}
